import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetOrderEmailSendReadinessQueryVariables = Types.Exact<{
  orderId: Types.Scalars['String']['input'];
  docType?: Types.InputMaybe<Types.OrderEmailDocType>;
}>;


export type GetOrderEmailSendReadinessQuery = { __typename?: 'Query', orderEmailSendReadiness?: { __typename?: 'OrderEmailSendReadinessData', routes: Array<{ __typename?: 'OrderEmailRouteReadinessData', route: Types.OrderEmailDeliveryRoute, isReady: boolean, blockers: Array<Types.OrderEmailSendBlocker> }> } | null };


export const GetOrderEmailSendReadinessDocument = new TypedDocumentString(`
    query GetOrderEmailSendReadiness($orderId: String!, $docType: OrderEmailDocType) {
  orderEmailSendReadiness(orderId: $orderId, docType: $docType) {
    routes {
      route
      isReady
      blockers
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetOrderEmailSendReadiness: build.query<GetOrderEmailSendReadinessQuery, GetOrderEmailSendReadinessQueryVariables>({
      query: (variables) => ({ document: GetOrderEmailSendReadinessDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetOrderEmailSendReadinessQuery, useLazyGetOrderEmailSendReadinessQuery } = injectedRtkApi;
